'use strict';

angular.module('ClinicApp').directive('loadingProgress', function($compile, $timeout) {
  return {
    restrict: 'A',
    scope: {
      resolve: '&',
      noDelay: '=',
    },
    link: function($scope, el) {
      $scope.loading = false;

      var button = el;
      var eventType = 'click';

      if (el[0].tagName == 'FORM') {
        button = el.find(':submit');
        eventType = 'submit';
      }

      el.on(eventType, function() {
        if ($scope.loading) {
          return;
        }
        $scope.loading = true;
        button.attr('disabled', '');
        button.addClass('btn-loading');

        $scope.resolve().finally(function() {
          var stopLoading = function() {
            $scope.loading = false;
            button.removeAttr('disabled');
            button.removeClass('btn-loading');
          };

          if ($scope.noDelay) {
            stopLoading();
          } else {
            $timeout(function() {
              stopLoading();
            }, 1000);
          }
        });
      });

      button.css('position', 'relative');
      var loadingEl = angular.element('<i class="fa fa-circle-o-notch fa-spin loading-spinner"></i>');
      $compile(loadingEl)($scope);
      button.append(loadingEl);
    },
  };
});
